import React from "react";
import { Box } from "@mui/material";

/**
 * Contenedor de rejilla dinamica para las vistas del dashboard.
 *
 * Rejilla CSS de 12 columnas (configurable) con gap tomado del tema. Cada hijo
 * decide cuanto ocupa via <Panel span={{ xs, sm, md, lg }} />. Asi cada vista
 * compone sus graficos sin estilos propios: solo declara cuanto ocupa cada uno.
 */
function DashboardGrid({ columns = 12, gap = 3, rowGap, columnGap, children, sx }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                gap,
                ...(rowGap != null && { rowGap }),
                ...(columnGap != null && { columnGap }),
                alignItems: "stretch",
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}

export const GRID_COLUMNS = 12;

export default DashboardGrid;
